"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsConfirmation = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var components_1 = require("../../../../shared/core/components");
var supplies_1 = require("../../../../shared/core/utils/supplies");
var kapi_meter_reads_1 = require("../../../kapi-meter-reads");
var MeterReadingsContext_1 = require("../../MeterReadingsContext");
var analytics_subjects_1 = require("../../analytics-subjects");
var utils_1 = require("../../components/MeterReadingsData/utils");
var MeterReadingsPage_1 = require("../../components/MeterReadingsPage");
var copy_1 = require("../../copy");
var section_ids_1 = require("../../section-ids");
var utils_2 = require("../../utils");
var utils_3 = require("../SubmitMeterReading/SubmitMeterReadingV2/utils");
var utils_4 = require("../SubmitMeterReading/utils");
var MeterReadingsConfirmation_styled_1 = require("./MeterReadingsConfirmation.styled");
var NextFuelReadingGuideLink_1 = require("./NextFuelReadingGuideLink");
function SuccessfulReadingCopy(_a) {
    var meterReading = _a.meterReading, peakMeterReading = _a.peakMeterReading, offpeakMeterReading = _a.offpeakMeterReading, anytimeMeterReading = _a.anytimeMeterReading, heatingMeterReading = _a.heatingMeterReading, eveningAndWeekendMeterReading = _a.eveningAndWeekendMeterReading, solarMeterReading = _a.solarMeterReading, shoulderMeterReading = _a.shoulderMeterReading, controlledLoad1MeterReading = _a.controlledLoad1MeterReading, controlledLoad2MeterReading = _a.controlledLoad2MeterReading, controlledLoad3MeterReading = _a.controlledLoad3MeterReading, intervalMeterReading = _a.intervalMeterReading, fuelType = _a.fuelType, readingDate = _a.readingDate, meterNumOfDigits = _a.meterNumOfDigits;
    var withLeadingZeros = function (value) {
        return (0, utils_2.applyLeadingZeros)(meterNumOfDigits, value);
    };
    var _b = (0, core_1.useComponents)(), Heading1 = _b.Heading1, Stack = _b.Stack;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var registerReads = (0, utils_3.readsFromParamValues)({
        peakMeterReading: peakMeterReading,
        offpeakMeterReading: offpeakMeterReading,
        anytimeMeterReading: anytimeMeterReading,
        heatingMeterReading: heatingMeterReading,
        eveningAndWeekendMeterReading: eveningAndWeekendMeterReading,
        solarMeterReading: solarMeterReading,
        shoulderMeterReading: shoulderMeterReading,
        controlledLoad1MeterReading: controlledLoad1MeterReading,
        controlledLoad2MeterReading: controlledLoad2MeterReading,
        controlledLoad3MeterReading: controlledLoad3MeterReading,
        intervalMeterReading: intervalMeterReading,
    });
    return (react_1.default.createElement("div", { "data-testid": "meter-confirm-success" },
        react_1.default.createElement(Heading1, null,
            react_1.default.createElement(Copy, { copyKey: "successfulReadingCopyHeading", values: { submittedFuelType: fuelType } })),
        react_1.default.createElement(Stack, { spaceBetween: [2, 3] },
            meterReading ? (react_1.default.createElement(MeterReadingsConfirmation_styled_1.RegisterBackground, null,
                react_1.default.createElement(components_1.RegisterSummary, { context: react_1.default.createElement(Copy, { copyKey: "newReadWithDate", values: {
                            value: withLeadingZeros(meterReading),
                            date: readingDate,
                        } }) }))) : null,
            registerReads.map(function (_a) {
                var timeOfUseLabel = _a.timeOfUseLabel, value = _a.value;
                return (react_1.default.createElement(MeterReadingsConfirmation_styled_1.RegisterBackground, { key: timeOfUseLabel },
                    react_1.default.createElement(components_1.RegisterSummary, { timingCategory: (0, utils_2.timeOfUseLabelToTimingCategory)(timeOfUseLabel), context: react_1.default.createElement(Copy, { copyKey: "newReadWithDate", values: {
                                value: withLeadingZeros(value),
                                date: readingDate,
                            } }) })));
            })),
        react_1.default.createElement(Copy, { copyKey: "successfulReadingCopy" })));
}
function PendingReadingCopy(_a) {
    var fuelType = _a.fuelType, meterPhotoName = _a.meterPhotoName, meterReading = _a.meterReading, peakMeterReading = _a.peakMeterReading, offpeakMeterReading = _a.offpeakMeterReading, msn = _a.msn, photoError = _a.photoError;
    var _b = (0, core_1.useComponents)(), Heading1 = _b.Heading1, P = _b.P;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement("div", { "data-testid": "meter-confirm-pending" },
        react_1.default.createElement(Heading1, null,
            react_1.default.createElement(Copy, { copyKey: "pendingReadingCopyHeading", values: { fuelType: fuelType } })),
        react_1.default.createElement(core_1.Feature, { feature: "meterPhoto" }, function (enabled) {
            return enabled ? (react_1.default.createElement(MeterReadingsConfirmation_styled_1.RegisterBackground, null,
                msn && (react_1.default.createElement(P, null,
                    react_1.default.createElement(Copy, { copyKey: "pendingReadingMsn", values: { msn: msn } }))),
                meterReading && (react_1.default.createElement(P, null,
                    react_1.default.createElement(Copy, { copyKey: "pendingReadingValue", values: { readValue: meterReading } }))),
                peakMeterReading && (react_1.default.createElement(P, null,
                    react_1.default.createElement(Copy, { copyKey: "pendingReadingPeakValue", values: { readValue: peakMeterReading } }))),
                offpeakMeterReading && (react_1.default.createElement(P, null,
                    react_1.default.createElement(Copy, { copyKey: "pendingReadingOffpeakValue", values: { readValue: offpeakMeterReading } }))),
                meterPhotoName && (react_1.default.createElement(P, null,
                    react_1.default.createElement(Copy, { copyKey: "pendingReadingPhotoName", values: {
                            meterPhotoName: decodeURIComponent(meterPhotoName),
                        } }))),
                photoError && (react_1.default.createElement(P, null,
                    react_1.default.createElement(Copy, { copyKey: "pendingReadingPhotoError" }))))) : null;
        }),
        react_1.default.createElement(Copy, { copyKey: "pendingReadingCopy" })));
}
function OpeningMeterReadingCopy(_a) {
    var meterReading = _a.meterReading, peakMeterReading = _a.peakMeterReading, offpeakMeterReading = _a.offpeakMeterReading, fuelType = _a.fuelType, supplyStartDate = _a.supplyStartDate, readingDate = _a.readingDate, meterNumOfDigits = _a.meterNumOfDigits;
    var omrWindowEndDate = (0, react_1.useMemo)(function () { return (supplyStartDate ? (0, supplies_1.getOMRWindowStatus)(supplyStartDate).endDate : ''); }, [supplyStartDate]);
    var withLeadingZeros = function (value) {
        return (0, utils_2.applyLeadingZeros)(meterNumOfDigits, value);
    };
    var Heading1 = (0, core_1.useComponents)().Heading1;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement("div", { "data-testid": "meter-confirm-omr" },
        react_1.default.createElement(Heading1, null,
            react_1.default.createElement(Copy, { copyKey: "successfulOMRCopyHeading", values: { submittedFuelType: fuelType } })),
        meterReading && (react_1.default.createElement(Copy, { copyKey: "successfulOMRCopySingleRate", values: {
                fuelType: fuelType === 'gas' ? 'gas' : 'electricity',
                meterReading: withLeadingZeros(meterReading),
                readingDate: readingDate,
            } })),
        peakMeterReading && offpeakMeterReading && (react_1.default.createElement(Copy, { copyKey: "successfulOMRCopyMultiRate", values: {
                fuelType: fuelType === 'gas' ? 'gas' : 'electricity',
                offpeakMeterReading: withLeadingZeros(offpeakMeterReading),
                peakMeterReading: withLeadingZeros(peakMeterReading),
                readingDate: readingDate,
            } })),
        react_1.default.createElement(Copy, { copyKey: "successfulOMRCopyResubmitWindow", values: {
                omrWindowEndDate: omrWindowEndDate
                    ? (0, date_fns_1.format)(omrWindowEndDate, 'do MMMM')
                    : '',
            } })));
}
function PageContentMain(_a) {
    var _b;
    var otherFuel = _a.otherFuel, searchParams = _a.searchParams, supplies = _a.supplies, readings = _a.readings, fuel = _a.fuel;
    var _c = (0, core_1.useComponents)(), P = _c.P, Card = _c.Card, Stack = _c.Stack;
    var _d = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _d.Copy, copy = _d.copy;
    var supplyIndex = searchParams.get('supplyIndex');
    var totalElecSupplies = supplies.electricity.length;
    var nextElecSupplyIndex = (0, utils_2.getNextSupplyIndex)(supplyIndex, totalElecSupplies);
    var supply = (0, utils_2.getSupplyMeterInfo)(supplies, fuel, supplyIndex ? Number(supplyIndex) : undefined);
    var otherLatestActualReading = (0, react_1.useMemo)(function () {
        return (0, utils_1.getLatestManualReading)(readings[otherFuel]);
    }, [readings, otherFuel]);
    // Prompt user to submit a reading for their other supply with the same fuel.
    var showSameFuelLink = (function () {
        if (fuel === 'gas' || nextElecSupplyIndex === null) {
            return false;
        }
        var nextSupply = (0, utils_2.getSupplyMeterInfo)(supplies, fuel, nextElecSupplyIndex);
        if (!nextSupply) {
            return false;
        }
        if (searchParams.get('isOMR') === 'true') {
            return otherLatestActualReading === undefined;
        }
        return (!(0, utils_2.hasManualReadingToday)(readings[fuel], nextSupply.mpxn) &&
            (!nextSupply.isSmart || nextSupply.isNonComms));
    })();
    // Prompt user to submit a reading for their other fuel.
    var showNextFuelLink = (function () {
        var otherSupply = (0, utils_2.getSupplyMeterInfo)(supplies, otherFuel);
        if (!otherSupply) {
            return false;
        }
        if (searchParams.get('isOMR') === 'true') {
            return otherLatestActualReading === undefined;
        }
        return (!(0, utils_2.hasManualReadingToday)(readings[otherFuel]) &&
            (!otherSupply.isSmart || otherSupply.isNonComms));
    })();
    var dateFromParm = searchParams.get('readingDate');
    var readingDate = dateFromParm ? new Date(dateFromParm) : new Date();
    var isPending = searchParams.get('isPending') === 'true';
    var isOMR = searchParams.get('isOMR') === 'true';
    var meterData = supply ? (0, utils_4.getMeterReadAnalyticsData)(supply, fuel) : null;
    return (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READINGS_SUCCESSFUL_SUBMIT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b.meterData = meterData, _b) },
        react_1.default.createElement(Card, null,
            react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
                react_1.default.createElement("div", null,
                    isPending ? (react_1.default.createElement(PendingReadingCopy, { fuelType: fuel, meterPhotoName: searchParams.get('meterPhotoName'), meterReading: searchParams.get('meterReading'), offpeakMeterReading: searchParams.get('offpeakMeterReading'), peakMeterReading: searchParams.get('peakMeterReading'), msn: searchParams.get('msn'), photoError: searchParams.get('photoError') === 'true' ? true : false })) : isOMR ? (react_1.default.createElement(OpeningMeterReadingCopy, { meterReading: searchParams.get('meterReading'), offpeakMeterReading: searchParams.get('offpeakMeterReading'), peakMeterReading: searchParams.get('peakMeterReading'), fuelType: fuel, supplyStartDate: supply === null || supply === void 0 ? void 0 : supply.start, readingDate: (0, date_fns_1.format)(readingDate, 'd MMM yyyy'), meterNumOfDigits: supply === null || supply === void 0 ? void 0 : supply.meterNumOfDigits })) : (react_1.default.createElement(SuccessfulReadingCopy, { meterReading: searchParams.get('meterReading'), offpeakMeterReading: searchParams.get('offpeakMeterReading'), peakMeterReading: searchParams.get('peakMeterReading'), anytimeMeterReading: searchParams.get('anytimeMeterReading'), heatingMeterReading: searchParams.get('heatingMeterReading'), solarMeterReading: searchParams.get('solarMeterReading'), shoulderMeterReading: searchParams.get('shoulderMeterReading'), controlledLoad1MeterReading: searchParams.get('controlledLoad1MeterReading'), controlledLoad2MeterReading: searchParams.get('controlledLoad2MeterReading'), controlledLoad3MeterReading: searchParams.get('controlledLoad3MeterReading'), eveningAndWeekendMeterReading: searchParams.get('eveningAndWeekendMeterReading'), intervalMeterReading: searchParams.get('intervalMeterReading'), fuelType: fuel, readingDate: (0, date_fns_1.format)(readingDate, 'd MMM yyyy'), meterNumOfDigits: supply === null || supply === void 0 ? void 0 : supply.meterNumOfDigits })),
                    showSameFuelLink && nextElecSupplyIndex !== null ? (react_1.default.createElement(P, null,
                        react_1.default.createElement(NextFuelReadingGuideLink_1.SameFuelReadingGuideLink, { fuel: fuel, supplyIndex: nextElecSupplyIndex },
                            react_1.default.createElement(Copy, { copyKey: "confirmationSendSameFuel", values: { fuel: fuel } })))) : showNextFuelLink ? (react_1.default.createElement(P, null,
                        react_1.default.createElement(NextFuelReadingGuideLink_1.NextFuelReadingGuideLink, { fuel: otherFuel },
                            react_1.default.createElement(Copy, { copyKey: "confirmationSendNextFuel", values: { otherFuel: otherFuel || '' } })))) : null,
                    react_1.default.createElement(Copy, { copyKey: "backToMeterReadings" })),
                react_1.default.createElement(core_1.FeedbackPrompt, { id: "meterReads", probability: 50, label: copy('feedbackPromptLabelMeterReading') })))));
}
function PageContainer() {
    var ErrorSection = (0, core_1.useComponents)().ErrorSection;
    var urlSearchParams = new URLSearchParams(window.location.search);
    var _a = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext), readings = _a.readings, supplies = _a.supplies;
    var fuel = urlSearchParams.get('fuel');
    var otherFuel = fuel === 'gas' ? 'electricity' : 'gas';
    return (0, utils_2.hasRequiredSearchParams)(urlSearchParams) ? (react_1.default.createElement(PageContentMain, { otherFuel: otherFuel, searchParams: urlSearchParams, readings: readings, supplies: supplies, fuel: fuel })) : (react_1.default.createElement(ErrorSection, { id: section_ids_1.METER_READ_PAGE_ERROR }));
}
exports.MeterReadingsConfirmation = (0, core_1.withCustomerAndAccountIds)(function () {
    var _a;
    var meterReads = core_1.configService.getConfig().meterReads;
    if (meterReads === null || meterReads === void 0 ? void 0 : meterReads.kapiOnly) {
        return react_1.default.createElement(kapi_meter_reads_1.KapiMeterReadingsConfirmation, null);
    }
    return (react_1.default.createElement(MeterReadingsPage_1.MeterReadingsPage, { name: analytics_subjects_1.METER_READINGS_SUCCESSFUL_SUBMIT, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
        react_1.default.createElement(PageContainer, null)));
});
